import React from "react";
import {
  Backdrop,
  CircularProgress,
  Container,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";
import {
  PageBodyDiv,
  Sidebar,
  PageHeadDiv,
  AlertDialog,
  ScrollDialog,
} from "../../../components";
import { AlertDialogData } from "../../../types";
import { errorToStr } from "../../../helpers";
import { DictionaryConfigContent } from "./DictionaryConfigContent";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // バックドロップ(ローディングスピナー)
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#FFF",
    },
    // 成功ダイアログ
    success: {
      color: theme.palette.success.main,
      verticalAlign: "middle",
    },
    divCheckIcon: {
      paddingTop: "0.5rem",
    },
    spanMsg: {
      verticalAlign: "middle",
      marginLeft: "0.25rem",
    },
  })
);

/** 辞書設定ページ */
export function DictionaryConfigPage() {
  const classes = useStyles();

  // アラートダイアログ
  const [alertDialogData, setAlertDialogData] = React.useState<AlertDialogData>(
    {
      open: false,
      title: "",
      message: "",
    }
  );
  const [closePost, setClosePost] = React.useState<() => void>();

  // Infoダイアログ
  const [infoDialogData, setInfoDialogData] = React.useState<{
    open: boolean;
    title: React.ReactNode;
    content: React.ReactNode;
  }>({
    open: false,
    title: <></>,
    content: <></>,
  });

  // Backdrop開閉
  const [backdropOpen, setBackdropOpen] = React.useState<boolean>(false);

  //--------------------
  // コンポーネント
  return (
    <div className="main-container">
      <div className="left-container">
        <Sidebar />
      </div>
      <div className="right-container">
        <PageHeadDiv title="辞書設定" />
        <PageBodyDiv>
          {/* <span>aaa</span> */}
          <div>
            <Container className="content-contaier">
              <div style={{ minWidth: 800 }}>
                <DictionaryConfigContent
                  // Info
                  onInfo={(title, content) => {
                    setInfoDialogData({
                      open: true,
                      title,
                      content,
                    });
                  }}
                  // 成功ダイアログ
                  onDialog={(title: string, onClose: () => void) => {
                    setAlertDialogData({
                      open: true,
                      title,
                      message: (
                        <div className={classes.divCheckIcon}>
                          <CheckCircle className={classes.success} />
                          <span className={classes.spanMsg}>
                            成功しました。
                          </span>
                        </div>
                      ),
                    });
                    // 追加の後処理を更新する
                    setClosePost(onClose);
                  }}
                  // エラー
                  onError={(error: any, onClose?: () => void) => {
                    setAlertDialogData({
                      open: true,
                      title: "エラー",
                      message: errorToStr(error),
                    });
                    if (onClose) {
                      onClose();
                    }
                  }}
                  // バックドロップ
                  onBackdrop={(open: boolean) => {
                    setBackdropOpen(open);
                  }}
                />
                {/*
                  アラートダイアログ

                */}
                <AlertDialog
                  data={alertDialogData}
                  handleClose={() => {
                    setAlertDialogData((prevState: AlertDialogData) => {
                      return { ...prevState, open: false };
                    });
                    if (closePost) {
                      // 追加の後処理
                      closePost();
                    }
                  }}
                />
                {/*
                  Infoダイアログ

                */}
                <ScrollDialog
                  open={infoDialogData.open}
                  handleClose={() => {
                    setInfoDialogData({
                      ...infoDialogData,
                      open: false,
                    });
                  }}
                  scroll="paper"
                  title={infoDialogData.title}
                  content={infoDialogData.content}
                />
              </div>
              {/*
                バックドロップ(ローディングスピナー)

              */}
              <Backdrop
                className={classes.backdrop}
                color="primary"
                open={backdropOpen}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </Container>
          </div>
        </PageBodyDiv>
      </div>
    </div>
  );
}
